/*
  Magic360 theme integration script.
  The original snippets/magic360.liquid inline script uses jQuery, but this theme
  ships no jQuery. This vanilla version wires up:
    - Preloading still-image slides so the first thumbnail click is instant.
    - Click-to-switch between the 360 spin slide and still-image slides.
  The core drag-to-spin is handled entirely by magic360.js (initialize-on:"load"),
  so nothing here interferes with rotation.
*/
(function () {
  'use strict';

  function initContainer(root) {
    var container = root.querySelector('.MagicToolboxContainer');
    if (!container) return;

    var slides = container.querySelectorAll('.MagicToolboxSlide');
    var selectors = container.querySelectorAll('.MagicToolboxSelectorsContainer a[data-slide-id]');

    // Preload non-spin slide images so thumbnail switching is snappy.
    container
      .querySelectorAll('.MagicToolboxSlide:not([data-slide-id="spin"]) > img')
      .forEach(function (img) {
        var src = img.getAttribute('src');
        if (!src) return;
        var preload = new Image();
        preload.src = src;
      });

    function activate(slideId) {
      slides.forEach(function (slide) {
        if (slide.getAttribute('data-slide-id') === slideId) {
          slide.classList.add('active-magic-slide');
        } else {
          slide.classList.remove('active-magic-slide');
        }
      });
      selectors.forEach(function (selector) {
        if (selector.getAttribute('data-slide-id') === slideId) {
          selector.classList.add('active-magic-selector');
        } else {
          selector.classList.remove('active-magic-selector');
        }
      });
    }

    selectors.forEach(function (selector) {
      selector.addEventListener('click', function (event) {
        event.preventDefault();
        var slideId = selector.getAttribute('data-slide-id');
        if (slideId) activate(slideId);
      });
    });
  }

  function init() {
    document
      .querySelectorAll('.product-media-container--magic360')
      .forEach(initContainer);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
